module.exports = __webpack_public_path__ + "sipgate-logo.svg?920b6c54d5d52f121991e4db9fc2bd5f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sipgate-logo.svg
// module id = 284
// module chunks = 0